import PackageAddIcon from '@/components/icons/PackageAddIcon';
import { Button } from '@/components/ui/button';
import NewOrder from '@/features/orders/components/NewOrder/NewOrder';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import OrdersInfoList from '@/features/orders/components/OrdersInfo/OrdersInfoList';
import { cn } from '@/lib/utils';
import { useUserRole } from '@/features/identity/hooks/useUserRole';
import { usePermissionsListApi } from '@/features/settings/hooks/usePermissionsListApi';
import { useMultiCurrencyStorage } from '@/features/hotels/hooks/useHotelMultiCurrencyStorage';

type Props = {
	isMobile?: boolean;
};

const OrdersInfo: FC<Props> = ({ isMobile }) => {
	const [showNewOrder, setShowNewOrder] = useState(false);

	const { t } = useTranslation();
	const userRole = useUserRole();
	const { permissionsListData: permissions } = usePermissionsListApi({
		role: userRole,
	});
	const { ordersEnabled } = useMultiCurrencyStorage();
	const canPlaceOrders = ordersEnabled && !!permissions?.placeOrders;

	return (
		<div className='h-full flex flex-col gap-4 select-none'>
			<div className='flex items-center justify-between gap-2'>
				<h3 className={cn(isMobile && 'text-base')}>
					{t('main.orders.components.list.title')}
				</h3>
				{canPlaceOrders && (
					<Button
						variant='outline'
						size={isMobile ? 'icon' : 'default'}
						onClick={() => setShowNewOrder(true)}>
						<PackageAddIcon className='stroke-popover-1000' />
						{!isMobile && t('elements.buttons.newOrder')}
					</Button>
				)}
			</div>
			<div
				className={cn(
					'grow p-6 flex flex-col gap-4 border border-popover-100 rounded-2.5xl bg-popover-10 text-sm',
					isMobile && 'p-0 border-0 bg-popover-30',
				)}>
				<OrdersInfoList isMobile={isMobile} />
			</div>
			{showNewOrder && (
				<NewOrder onClose={() => setShowNewOrder(false)} />
			)}
		</div>
	);
};

export default OrdersInfo;
